import { Injectable } from '@angular/core';
import {ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class PortalTimezoneService {

    constructor(private api: ApiService) { }

    findTimezonesByPortalPk(pkPortal: number): Observable<any>{
        return this.api.get('vna/timezone', {portal_pk: pkPortal});
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/services/portal-timezone.service.ts